
;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.ExtendedLeaguesInvites = View.LeaguesInvites.extend({
		ui: {
			add_invite:        '',
			send_invites:      '',
			send_list_invites: '',
			input_invite:      '',
			share_btn:         '',
			gmail_btn:         '',
			modal_container:   '',
			modal:             '',
			modal_content:     '',
			select:            '',
			select_all:        '',
			emails_list:       '',
			emails_message:    '',
			url_field:         '',
			copy_link:         '',
			success_message:   ''
		},
		events: {
			'click @ui.add_invite':        'initData',
			'click @ui.send_invites':      'sendInvites',
			'click @ui.send_list_invites': 'sendListOfInvites',
			'change @ui.input_invite':     'changeInvite',
			'click @ui.share_btn':         'shareInvite',
			'click @ui.gmail_btn':         'showModal',
			'change @ui.select':           'toggleModalCheckbox',
			'change @ui.select_all':       'toggleModalCheckbox',
			'click @ui.modal_close':       'closeModal',
			'click @ui.modal_submit':      'submitModal',
			'click @ui.copy_link':         'copyLink'
		},
		copyOnlyCode: false, // code or full url to join
		sendListOfInvites: function() {
			var list    = [],
				invites = this.extractEmails(),
				message = $(this.ui.emails_message).val();

			list = _.map(invites, function(invite){
				return {
					"email": invite,
					"first_name": ''
				}
			});

			if (list.length) {
				this.showPreloader();
				this.league.invite(list, message);
			}

			return this;
		},
		extractEmails: function () {
			return $(this.ui.emails_list).val().match(/([a-zA-Z0-9._+-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi);
		},
		getJoinToLeagueUrl: function() {
			var url = Backbone.history.fragment.replace(/manage/, '').replace(/\/invites/,'');
			return this.copyOnlyCode ? this.league.get('code') : (CONFIG.ABSPATH + '#' + url + 'join/' + this.league.get('code'));
		},
		copyLink: function (e) {

			this.clipboard = new Clipboard($(this.ui.copy_link).data('el'));

			var $field = $(this.ui.url_field);

			$field.show();
			$field.val(this.getJoinToLeagueUrl());

			this.copyText();

			return this;
		},

		copyText: function () {
			var _this = this;

			this.clipboard.on('success', function(e) {
				$(_this.ui.success_message).show();
				e.clearSelection();
			});

			this.clipboard.on('error', function(e) {
				$(_this.ui.success_message).html('Press Ctrl+C to copy');
				$(_this.ui.success_message).show();
			});

			return this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));